import {
  Building,
  IPropertyDetailsResponse,
  Unit
} from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { C_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { formatDate } from "@/shared/helpers/format-date";
import { PROPERTIES_STATUS_FOR_ID } from "@/shared/models/const/properties/properties-status.const";

export const prepareDetailPropertyBuildings = (
  data: IPropertyDetailsResponse
): IBuildingFromDetail[] => {
  if (!data?.project_id) {
    return [];
  }

  return (
    data?.project?.buildings?.map((building: Building) => ({
      id: building.id,
      nameBuilding: building.description || "",
      deliveryDate: building.delivers ? formatDate(building.delivers) : "",
      unit:
        building.units?.map((unit: Unit) => ({
          id: unit.id,
          status:
            unit.status_id !== undefined && unit.status_id !== null
              ? PROPERTIES_STATUS_FOR_ID[
                  unit.status_id as keyof typeof PROPERTIES_STATUS_FOR_ID
                ].name
              : C_PROPERTIES_STATUS.ERROR.label,
          status_id: unit.status_id,
          name: unit.name || "",
          bedrooms: unit.bedrooms ? Number(unit.bedrooms) : 0,
          bathrooms: unit.bathrooms ? Number(unit.bathrooms) : 0,
          parking: unit.parking_spots ? Number(unit.parking_spots) : 0,
          sqmConstruction: unit.sqm_construction ? Number(unit.sqm_construction) : 0,
          sqmLand: unit.sqm_land ? Number(unit.sqm_land) : 0,
          currency: (unit.currency_id === 1 ? C_CURRENCY.RD : C_CURRENCY.USD).value,
          price: unit.price ? Number(unit.price) : 0,
          floorLevel: unit.floor_level ? Number(unit.floor_level) : 0,
          parent_id: unit.parent_id,
          half_bathrooms: unit.half_bathrooms,
          parking_spots: unit.parking_spots,
          sqm_construction: unit.sqm_construction,
          sqm_land: unit.sqm_land,
          currency_id: unit.currency_id,
          floor_level: unit.floor_level,
          pivot: unit.pivot
        })) || []
    })) || []
  );
};

export interface IBuildingFromDetail {
  id: number;
  nameBuilding: string;
  deliveryDate: string;
  unit: IUnitFromDetail[] | [];
}

export interface IUnitFromDetail {
  id: number;
  status: string;
  status_id?: number;
  name: string;
  bedrooms: number;
  bathrooms: number;
  parking: number;
  sqmConstruction: number;
  sqmLand: number;
  currency: string;
  price: number;
  floorLevel: number;
  parent_id?: number;
  half_bathrooms?: number;
  parking_spots?: number;
  sqm_construction?: string;
  sqm_land?: string;
  currency_id?: number;
  floor_level?: number;
  pivot?: any;
  realstatetype_id?: number;
}
